import React from "react";
import "./AccessDeniedPopup.css";
const AccessDeniedPopup = ({ onClose }) => {
  return (
    <div class="popup-overlay">
      <div class="popup-box">
        <h2>🚫 Access Denied</h2>
        <p>
          Your account is <strong>inactive</strong>. Kindly contact the
          administrator to restore access.
        </p>
        <button class="popup-btn" onClick={onClose}>
          Okay
        </button>
      </div>
    </div>
  );
};

export default AccessDeniedPopup;
